import type { ComponentType, ReactNode, SVGProps } from "react";
import { Card } from "@astryxdesign/core/Card";
import { Heading } from "@astryxdesign/core/Heading";
import { Icon } from "@astryxdesign/core/Icon";
import { HStack } from "@astryxdesign/core/Stack";
import { VStack } from "@astryxdesign/core/VStack";

/** One titled block of the studio page: icon + heading, then its content. */
export function InfoBlock({ icon, title, children }: { icon: ComponentType<SVGProps<SVGSVGElement>>; title: string; children: ReactNode }) {
  return (
    <Card padding={5} className="info-block">
      <VStack gap={4}>
        <HStack gap={3} vAlign="center">
          <HStack hAlign="center" vAlign="center" className="info-block-icon">
            <Icon icon={icon} color="inherit" />
          </HStack>
          <Heading level={2}>{title}</Heading>
        </HStack>
        {children}
      </VStack>
    </Card>
  );
}
